/**
 *
 * Card
 *
 */

import React from 'react';
import './styles.css';
import { Card as CustomCard } from 'antd';

const Card = ({ ...rest }) => {
  return <CustomCard {...rest} />;
};

export default Card;
